import { render, staticRenderFns } from "./404.vue?vue&type=template&id=62d6c3d5&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=62d6c3d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d6c3d5",
  null
  
)

export default component.exports